const sugg = [
  'gpt',
  'gn',
  'coffee',
  'hello',
  'yp',
  'urt'
];

export default sugg;
